<template>
    <div class="w-[160px] p-[11px] bg-white fixed top-[140px] right-10 rounded-[8px] flex flex-col items-center gap-2">
        <h3 class="uppercase text-center text-[14px] text-[#686e77] tracking-[0.56px]">
            Resume score
        </h3>

        <ScoreCircle
          :progress="score?.totalScore"
        />
        
        <button
            class="text-won-green font-medium mx-auto w-fit"
            @click="openResumeScorerHandler"
        >
            Show More
        </button>
    </div>
</template>

<script setup>
import { toRefs, watch, ref } from 'vue'
import { storeToRefs } from 'pinia'

import { useBuilder } from '../../store/builder.store';
import { useResumeScorerStore } from "../../store/scorer.store";
import { useBuilderStyles } from "../../store/builder-style.store";
import { useSubscriptionPlanStore } from "../../store/subscription.store";
import { useFeatureUsageStore } from '../../store/feature-usage.store'; 

import ScoreCircle from './score-circle.vue';
import { useSidebarStore } from '../../store/sidebar.store';

const builder = useBuilder();
const scorerStore = useResumeScorerStore();
const stylesStore = useBuilderStyles();
const subscriptionStore = useSubscriptionPlanStore();
const featuresUsageStore = useFeatureUsageStore();
const sidebarStore = useSidebarStore()

const { collapsed: isSidebarCollapsed } = storeToRefs(sidebarStore)

const { 
    resumeCopy,
    lastResumeName,
    lastResumeContact,
    margins,
    getScore: score,
} = storeToRefs(scorerStore);

const { isSubscribe } = storeToRefs(subscriptionStore)

const { loaded, data, bulletPointsWithId } = storeToRefs(builder);
const { textSize, leftMargin, rightMargin } = storeToRefs(stylesStore);

const props = defineProps({
    showPanel: {
        type: Function,
        default: () => {}
    }
})

const openResumeScorerHandler = () => {
    if(isSubscribe.value) {
        scorerStore.setShowResumeScorer();

        if(!isSidebarCollapsed.value) {
            sidebarStore.sidebarCollapseHandler()
        }
    } else {
        featuresUsageStore.setShowLimitExceed('resume_scorer');
    }
}

// watchers
watch(bulletPointsWithId, () => {
    if (!loaded.value) return;

    scorerStore.bulletPointsChangeHandler();
    scorerStore.relevantInfoChangeHandler();
  });

watch(data, (newValue, oldValue) => {
    if (!loaded.value) return;
    resumeCopy.value = newValue;

    // first initialization
    if(!oldValue) {
        scorerStore.initScorer();
    }
    else {
        if(lastResumeName.value !== newValue.name || lastResumeContact.value !== newValue.contact) {
            scorerStore.resumeContactChangeHandler();
        }
        
        scorerStore.sectionsFormatingChangeHandler();
        scorerStore.relevantInfoExperienceChangeHandler();
        scorerStore.experienceOrderChangeHandler();
        scorerStore.experiencePopulationChecker();
        scorerStore.educationInfoChangeHandler();
        scorerStore.experienceInfoChangeHandler();
        scorerStore.relevantInfoChangeHandler();
        scorerStore.skillsChangeHandler();
    }
  }, { deep: true });

watch([rightMargin, leftMargin], ([newRight, newLeft]) => {
    if (!loaded.value) return;

    margins.value[0] = newRight;
    margins.value[1] = newLeft;

    scorerStore.marginsChangeHandler();
  }, { deep: true });

watch(textSize, () => {
    if (!loaded.value) return;
    scorerStore.fontChangeHandler();
  }, { deep: true });
</script>
